/**
 * Feature Flags Configuration
 * Controls visibility of features in Public Beta
 * 
 * To enable a feature:
 * 1. Set the flag to true here, OR
 * 2. Set environment variable (e.g., REACT_APP_ENABLE_WORKFLOWS=true)
 */

const featureFlags = {
  // Workflows feature - hidden in Public Beta
  // Set REACT_APP_ENABLE_WORKFLOWS=true to enable
  ENABLE_WORKFLOWS: process.env.REACT_APP_ENABLE_WORKFLOWS === 'true' || false,
  
  // Phase 3: System Linking — deterministic opportunity→system matching
  SYSTEM_LINKING_V1: process.env.REACT_APP_SYSTEM_LINKING_V1 === 'true' || true,
};

export default featureFlags;
